import { getKeyByValue } from './general';
const SETTING_EXTRA_PARAMS = [ 'design_origin' ];
const isSettingFilterParam = (key: string): boolean => /^[A-Z]/.test(key) || SETTING_EXTRA_PARAMS.includes(key);
const DIAMOND_FILTER_PARAMS: Record<string, string> = {
  shape: 'diamond_shape',
  carat: 'diamond_carat',
  source: 'source',
  diamond_price: 'diamond_price',
  ratio: 'ratio',
  table_per: 'table_per',
  depth: 'depth',
  color: 'color',
  cut: 'cut',
  clarity: 'clarity',
  fluorecence: 'fluorecence',
  polish: 'polish',
  symmetry: 'symmetry',
  lab: 'lab',
  sustainable: 'sustainable',
};
type FilterSystem = 'setting' | 'diamond';

const ARRAY_KEYS: Record<FilterSystem, string[]> = {
  setting: [ 'Ring_Style' ],
  diamond: [ 'lab' ],
};
const BOOLEAN_KEYS: Record<FilterSystem, string[]> = {
  setting: [],
  diamond: [ 'sustainable' ],
};

export const serializeFilterOptions = (
  options: Record<string, string | string[] | boolean>,
  system: FilterSystem
): Record<string, string> => {
  const result: Record<string, string> = {};
  Object.entries(options).forEach(([ key, value ]) => {
    if (value === undefined || value === null || value === '') return;
    const paramKey = system === 'diamond' ? (DIAMOND_FILTER_PARAMS[key] || key) : key;
    result[paramKey] = Array.isArray(value) ? value.join(',') : String(value);
  });
  return result;
};

export const deserializeFilterOptions = (
  params: Record<string, string>,
  system: FilterSystem
): Record<string, string | string[] | boolean> => {
  const arrayKeys = ARRAY_KEYS[system];
  const booleanKeys = BOOLEAN_KEYS[system];
  const result: Record<string, string | string[] | boolean> = {};
  Object.entries(params).forEach(([ paramKey, value ]) => {
    if (!value) return;
    let key: string | undefined;
    if (system === 'setting') {
      key = isSettingFilterParam(paramKey) ? paramKey : undefined;
    } else {
      key = getKeyByValue(DIAMOND_FILTER_PARAMS, paramKey);
    }
    if (!key) return;
    if (arrayKeys.includes(key)) {
      result[key] = value.split(',').filter(Boolean);
    } else if (booleanKeys.includes(key)) {
      result[key] = value === 'true';
    } else {
      result[key] = value;
    }
  });
  return result;
};
